export default __webpack_public_path__ + "eacfeba94baab26374e55533c496ac7f.png";